"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var config = {
  "HOST": process.env['VUE_APP_HOST'],
  "REGION": process.env['VUE_APP_REGION'],
  "PATH": process.env['VUE_APP_PATH'],
  "ENDPOINT": process.env['VUE_APP_ENDPOINT'],
  "KEY": process.env['VUE_APP_KEY'],
  "WSENDPOINT": process.env['VUE_APP_WSENDPOINT']
};
config.ENDPOINT = "https://" + config.HOST + config.PATH;
config.WSENDPOINT = config.WSENDPOINT
exports.default = config;
